export default "__VITE_ASSET__4f9BZutq__"